exports = module.exports = require("../../../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-editor .color-card{margin:2px;width:30px;height:30px;float:left;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-4c3fcb50!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/editor/src/modules/color/dashboard.vue
// module id = 473
// module chunks = 0